import React from 'react';

interface InitializationErrorProps {
  title: string;
  lastFailureReason?: string;
  initializationAttempts: number;
  onRetry: () => void;
  onShowDiagnostics?: () => void;
  showDiagnosticsButton?: boolean;
  solutions: string[];
}

function InitializationError({
  title,
  lastFailureReason,
  initializationAttempts,
  onRetry,
  onShowDiagnostics,
  showDiagnosticsButton,
  solutions,
}: InitializationErrorProps) {
  return (
    <div className="mt-4 rounded-md border border-red-200 bg-red-50 p-3">
      <div className="mb-3">
        <h4 className="mb-1 text-sm font-medium text-red-800">{title}</h4>
        {lastFailureReason && (
          <p className="mb-2 text-xs text-red-700">
            <strong>Reason:</strong> {lastFailureReason}
          </p>
        )}
        {initializationAttempts > 0 && (
          <p className="mb-2 text-xs text-red-600">Attempts: {initializationAttempts}</p>
        )}
      </div>
      <div className="flex gap-2">
        <button
          onClick={onRetry}
          className="rounded bg-red-600 px-3 py-1 text-xs text-white hover:bg-red-700"
        >
          Try Again
        </button>
        {showDiagnosticsButton && onShowDiagnostics && (
          <button
            onClick={onShowDiagnostics}
            className="rounded bg-gray-500 px-3 py-1 text-xs text-white hover:bg-gray-600"
            title="Show diagnostic information (Development only)"
          >
            Debug Info
          </button>
        )}
      </div>
      <div className="mt-3 text-xs text-red-600">
        <p className="font-medium">Try these solutions:</p>
        <ul className="mt-1 list-inside list-disc space-y-1">
          {solutions.map((solution, idx) => (
            <li key={idx}>{solution}</li>
          ))}
        </ul>
      </div>
    </div>
  );
}

export default InitializationError;
